import * as _ from 'lodash';
import { Glyphicon, Row } from 'react-bootstrap';
import { ToDoColumnWrapper } from '../styles';
import { ActionItem } from '../models';
import { IAdminActionCenterCompliance } from '@nkr/models/index';
import ActionCenterItem from './action-center-item-count';
import { MainType } from './models/main-type';
import { useState } from 'react';

interface IProps {
    data: IAdminActionCenterCompliance,
    showLoading: boolean,
    hideEmptyItems: boolean,
    isAdmin: boolean,
    onItemClick: (mainType: MainType, subType: ActionItem) => void
}

const ComplianceCountsOnly = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const handleItemClick = (subType: ActionItem) => {
        props.onItemClick(MainType.Compliance, subType);
    };

    const activeRecipientsDataCompliance = props.data != null ? props.data.complianceRecipientList : 0;
    const postTransplantRecipientsDataCompliance = props.data != null ? props.data.postTransplantComplianceRecipientList : 0;
    const activeDonorsDataCompliance = props.data != null ? props.data.complianceDonorList : 0;
    const activeRdnDonorsDataCompliance = props.data != null ? props.data.complianceRdnDonorList : 0;
    const postTransplantDonorsDataCompliance = props.data != null ? props.data.postTransplantComplianceDonorList : 0;
    const postTransplantRdnDonorsDataCompliance = props.data != null ? props.data.postTransplantComplianceRdnDonorList : 0;
    const centerContactsDataCompliance = props.data != null ? props.data.centerContactsDataCompliance : 0;
    const centerWaitListAnatomyCompliance = props.data != null ? props.data.complianceWaitListAnatomyList : 0;

    const items = [
        { name: 'Active Recipient Data Compliance', count: activeRecipientsDataCompliance, actionItem: ActionItem.ActiveRecipientDataCompliance },
        { name: 'Post Txp Recipient Data Compliance', count: postTransplantRecipientsDataCompliance, actionItem: ActionItem.PostTransplantRecipientDataCompliance },
        { name: 'Active Donor Data Compliance', count: activeDonorsDataCompliance, actionItem: ActionItem.ActiveDonorDataCompliance },
        { name: 'Active RDN Donor Data Compliance', count: activeRdnDonorsDataCompliance, actionItem: ActionItem.ActiveRdnDonorDataCompliance },
        { name: 'Post Txp Donor Data Compliance', count: postTransplantDonorsDataCompliance, actionItem: ActionItem.PostTransplantDonorDataCompliance },
        { name: 'Post Txp RDN Donor Data Compliance', count: postTransplantRdnDonorsDataCompliance, actionItem: ActionItem.PostTransplantRdnDonorDataCompliance },
        { name: 'Center Contacts Data Compliance', count: centerContactsDataCompliance, actionItem: ActionItem.CenterContactPositions },
        { name: 'Center Wait List Anatomy Compliance', count: centerWaitListAnatomyCompliance, actionItem: ActionItem.WaitListAnatomyCompliance }
    ];

    const isEmpty = items.filter(x => x.count == 0).length == items.length;
    const itemCount = items.filter(x => x.count > 0).length;
    const itemList = _.sortBy(items, item => item.name);

    let title = props.isAdmin ? 'COMPLIANCE - All Centers' : 'COMPLIANCE';

    return (
        <div className='section-compliance' style={{ marginBottom: 20 }}>
            <div className='title-container'>
                <div className={props.isAdmin ? 'title admin-title' : 'title'} onClick={() => setExpanded(!expanded)}>
                    <h4>{title} <span>({itemCount})</span></h4>
                    <span style={{ paddingLeft: 5 }}><Glyphicon glyph={expanded ? 'chevron-down' : 'chevron-up'} /></span>
                </div>
                <div style={{ borderBottom: '1px solid cadetblue', width: '85%' }}>&nbsp;</div>
            </div>
            {expanded ?
                <div className='content' style={{ backgroundColor: props.showLoading ? '#eee' : null, opacity: props.showLoading ? 0.5 : 1 }}>
                    {props.showLoading && (
                        <div className="loader"><div className='message'>Loading upcoming items, one moment please...</div></div>
                    )}

                    <div className='container-fluid'>
                        <Row>
                            {itemList.map((item, index) => {
                                if ((!props.hideEmptyItems && item.count == 0) || item.count > 0) {
                                    return (
                                        <ToDoColumnWrapper key={index} className='col-xs-12 col-lg-6'>
                                            <ActionCenterItem
                                                description={item.name}
                                                count={item.count}
                                                isList={true}
                                                color='black'
                                                highlight='aliceblue'
                                                actionItem={item.actionItem}
                                                onItemClick={handleItemClick}
                                            />
                                        </ToDoColumnWrapper>
                                    )
                                }
                            })}
                        </Row>

                        {isEmpty && props.hideEmptyItems && (
                            <ToDoColumnWrapper className='col-xs-12 col-lg-12' style={{ fontSize: 16 }}>
                                At this time, there are no upcoming items
                            </ToDoColumnWrapper>
                        )}
                    </div>
                </div>
                :
                <div className='content collapsed'></div>
            }
        </div>
    )
}

export default ComplianceCountsOnly;